export { default } from './TechCoachCTA';



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/components/TechCoachCTA/index.ts